import { render, staticRenderFns } from "./LandingConfigError.vue?vue&type=template&id=a7887ff4"
import script from "./LandingConfigError.vue?vue&type=script&lang=js"
export * from "./LandingConfigError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports